import React from "react";
import moment from "moment-timezone";
import { Modal, Input } from "antd";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import * as R from "ramda";
import { ErrorMessage as Error } from "formik";

import {
  FormConfig,
  Field
} from "../../../../../../../components/controls/FormikForm";
import i18n from "../../../../../../../i18n";
import Message from "../../../../../../../components/feedback/Message";
import DatePicker from "../../../../../../../components/inputs/DatePicker";
import TimePicker from "../../../../../../../components/inputs/TimePicker";
import ErrorMessage from "../../../../../../../components/controls/FormikForm/ErrorMessage";
import Button from "../../../../../../../components/Button";

import { parseRoom, formatRoom } from "./selectors";

import styled from "styled-components/macro";

const baseRoom = {
  name: "",
  candidates: []
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required(i18n.t("form:emptyFieldValidation")),
  day: Yup.string().required(i18n.t("form:emptyFieldValidation")),
  start: Yup.string().required(i18n.t("opportunity:process.rooms.startEmpty")),
  end: Yup.string()
    .when("start", (start, schema) =>
      schema.test(
        "is-later",
        i18n.t("opportunity:process.rooms.timeError"),
        end => end > start
      )
    )
    .required(i18n.t("opportunity:process.rooms.endEmpty"))
});

const StartEnd = styled.div`
  display: flex;
  flex-wrap: wrap;
  > div:last-of-type {
    margin-left: 20px;
  }
`;

const ErrorContainer = styled.div`
  margin: -12px 0 12px;
`;

const Create = ({ t, onSubmit, onCancel, isLoading }) => (
  <FormConfig
    validationSchema={validationSchema}
    initialValues={parseRoom(baseRoom)}
    onSubmit={R.pipe(
      formatRoom,
      onSubmit
    )}
  >
    {({ isValid, handleSubmit, values }) => (
      <Modal
        visible
        destroyOnClose
        onCancel={onCancel}
        title={t("opportunity:process.rooms.addRoom")}
        width={700}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            {t("global:cancel")}
          </Button>,
          <Button
            key="submit"
            disabled={!isValid}
            loading={isLoading}
            type="primary"
            htmlType="submit"
            onClick={handleSubmit}
          >
            {t("global:add")}
          </Button>
        ]}
      >
        <Field name="name" label={t("global:name")}>
          <Input type="text" />
        </Field>
        <Field name="day" label={t("opportunity:process.rooms.date")}>
          <DatePicker
            disabledDate={calendarDate => calendarDate.valueOf() < Date.now()}
          />
        </Field>
        <StartEnd>
          <Field
            showError={false}
            name="start"
            label={t("opportunity:process.rooms.startTime")}
          >
            <TimePicker defaultOpenValue={moment().format("HH:mm")} />
          </Field>
          <Field
            showError={false}
            name="end"
            label={t("opportunity:process.rooms.endTime")}
          >
            <TimePicker
              defaultOpenValue={moment(values.start, "HH:mm")
                .add("30", "minutes")
                .format("HH:mm")}
            />
          </Field>
        </StartEnd>
        <ErrorContainer>
          <Error name="start" component={ErrorMessage} />
          <Error name="end" component={ErrorMessage} />
        </ErrorContainer>
        <Message type="primary-lighter">
          {t("opportunity:process.rooms.timezoneMessage", {
            time: moment.tz
              .guess()
              .replace("/", " - ")
              .replace("_", " ")
          })}
        </Message>
      </Modal>
    )}
  </FormConfig>
);

export default withTranslation(["global", "opportunity"])(Create);
